var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"section-item mb-5"},[_c('h3',{staticClass:"is-size-5 has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }